/* ============================================================
   Aonic Complete Quiz — lp-co-aonic-complete-quiz.js
   State machine for sections/lp-co-aonic-complete-quiz.liquid.
   Static quiz content per approved scope; results copy, CTA
   URLs, images, and timing values are read from the section's
   Liquid-rendered data-* attributes (merchant-editable).

   LIFECYCLE NOTE: the Shopify theme editor replaces this
   section's DOM in place on every settings change and fires
   shopify:section:load. Initialization is therefore guarded
   PER-ELEMENT (root.dataset.lpCoInit), never with a page-global
   one-shot flag — a global flag would block re-initialization
   and leave the re-rendered DOM unwired (blank questions,
   progress fills stuck at scaleX(0), dead clicks).
   Timers/listeners are tracked on window so whichever closure
   owns them can always be torn down, since inline section
   scripts are not guaranteed to re-execute on re-render.
   ============================================================ */
(function () {
  var MICROCOPY = [
    'Daily Essential Nutrition',
    '34 key ingredients',
    'Third-party tested',
    'HERS & HIS editions',
    'One daily ritual',
    'Designed for real life'
  ];

  var QUESTIONS = [
    {
      sec: 0, eyebrow: 'About you', title: "What's your age range?",
      helper: 'This helps us understand your daily nutrition routine by life stage.',
      multi: false, max: 1,
      options: [
        { emoji: '', label: '18–29' },
        { emoji: '', label: '30–39' },
        { emoji: '', label: '40–49' },
        { emoji: '', label: '50–59' },
        { emoji: '', label: '60+' }
      ]
    },
    {
      sec: 0, eyebrow: 'About you', title: 'What brings you here today?',
      helper: 'Select the option that best describes your primary motivation.',
      multi: false, max: 1,
      options: [
        { emoji: '🎯', label: 'I want to simplify my supplement routine' },
        { emoji: '🥗', label: 'I want more complete daily nutrition' },
        { emoji: '💼', label: 'I want something that fits a busy lifestyle' },
        { emoji: '💪', label: 'I want daily support for energy and performance' },
        { emoji: '⏳', label: "I'm focused on long-term wellness" }
      ]
    },
    {
      sec: 0, eyebrow: 'Goals', title: 'What daily support matters most to you?',
      helper: 'Select up to 4 that resonate most.',
      multi: true, max: 4,
      options: [
        { emoji: '⚡', label: 'Cellular energy support' },
        { emoji: '🦠', label: 'Gut health and digestion' },
        { emoji: '🛡️', label: 'Immune health support' },
        { emoji: '🧠', label: 'Brain and focus support' },
        { emoji: '❤️', label: 'Heart and whole-body wellness' },
        { emoji: '✨', label: 'Healthy hair, skin, and nails' },
        { emoji: '🦴', label: 'Bone and joint support' },
        { emoji: '💊', label: 'A simpler daily supplement routine' }
      ]
    },
    {
      sec: 1, eyebrow: 'Routine', title: 'What usually gets in the way of staying consistent?',
      helper: 'Choose the answer that feels most true.',
      multi: false, max: 1,
      options: [
        { emoji: '💊', label: 'Too many pills or bottles' },
        { emoji: '⏰', label: 'Busy mornings' },
        { emoji: '✈️', label: 'Travel or being away from home' },
        { emoji: '🤔', label: 'Not knowing what I actually need' },
        { emoji: '🔁', label: 'I start routines, then fall off' }
      ]
    },
    {
      sec: 1, eyebrow: 'Routine', title: 'What best describes your current eating style?',
      helper: 'This helps us understand how your daily routine may vary.',
      multi: false, max: 1,
      options: [
        { emoji: '🍽️', label: 'Standard / no specific diet' },
        { emoji: '🥩', label: 'Low-carb or keto-inspired' },
        { emoji: '🥬', label: 'Plant-based or mostly plant-based' },
        { emoji: '🫒', label: 'Mediterranean-style' },
        { emoji: '⏰', label: 'Intermittent fasting' },
        { emoji: '🔄', label: 'It changes week to week' }
      ]
    },
    {
      sec: 1, eyebrow: 'Routine', title: 'Where would a daily nutrition routine need to fit?',
      helper: 'Choose the setting that sounds most like your life.',
      multi: false, max: 1,
      options: [
        { emoji: '🏠', label: 'At home in the morning' },
        { emoji: '💼', label: 'Between work, errands, and meetings' },
        { emoji: '✈️', label: 'On the go or while traveling' },
        { emoji: '🏋️', label: 'Around workouts or active days' },
        { emoji: '🔄', label: 'It needs to work anywhere' }
      ]
    },
    {
      sec: 2, eyebrow: 'Daily support', title: 'How would you describe your digestion day to day?',
      helper: 'This helps us understand whether gut health support is important to your routine.',
      multi: false, max: 1,
      options: [
        { emoji: '😣', label: 'Often feels off' },
        { emoji: '😕', label: 'Sometimes unpredictable' },
        { emoji: '🙂', label: 'Usually steady' },
        { emoji: '😊', label: 'Rarely something I think about' }
      ]
    },
    {
      sec: 2, eyebrow: 'Daily support', title: 'Which areas would you like your daily routine to support?',
      helper: 'Select all that apply.',
      multi: true, max: 5,
      options: [
        { emoji: '🛡️', label: 'Immune health' },
        { emoji: '⚡', label: 'Cellular energy' },
        { emoji: '🦠', label: 'Gut health' },
        { emoji: '🧠', label: 'Brain health and focus' },
        { emoji: '❤️', label: 'Heart health' },
        { emoji: '✨', label: 'Hair, skin, and nails' },
        { emoji: '🦴', label: 'Bones and joints' },
        { emoji: '✅', label: 'Overall daily wellness' }
      ]
    },
    {
      sec: 2, eyebrow: 'Daily support', title: 'How many supplements do you currently take daily?',
      helper: 'This helps us understand how simple or complex your routine feels today.',
      multi: false, max: 1,
      options: [
        { emoji: '0️⃣', label: 'None' },
        { emoji: '💊', label: '1–3 supplements' },
        { emoji: '💊💊', label: '4–7 supplements' },
        { emoji: '💊💊💊', label: '8–15 supplements' },
        { emoji: '🏆', label: '16+ supplements' }
      ]
    }
  ];

  var ROOT_ID = 'lp-co-aonic-complete-quiz';
  var ACTIVE_CLASS = 'lp-co-aonic-complete-quiz-active';

  /* Drop timers/listeners owned by a DOM that has been removed. */
  function teardown() {
    document.documentElement.classList.remove(ACTIVE_CLASS);
    document.body.classList.remove(ACTIVE_CLASS);
    if (window.__lpCoAonicQuizTimer) {
      clearInterval(window.__lpCoAonicQuizTimer);
      window.__lpCoAonicQuizTimer = null;
    }
    var fns = window.__lpCoAonicQuizCleanup || [];
    for (var i = 0; i < fns.length; i++) {
      try { fns[i](); } catch (e) { /* nothing actionable */ }
    }
    window.__lpCoAonicQuizCleanup = [];
  }

  function init() {
    var root = document.getElementById(ROOT_ID);
    if (!root) return;
    if (root.dataset.lpCoInit) return;
    root.dataset.lpCoInit = '1';

    teardown();
    window.__lpCoAonicQuizCleanup = [];

    /* Suppress the store's global header/announcement/footer for this page.
       Paired with a :has() rule in the CSS so there is no flash before JS runs;
       this class is the fallback for browsers without :has(). */
    document.documentElement.classList.add(ACTIVE_CLASS);
    document.body.classList.add(ACTIVE_CLASS);

    var AUTO_ADVANCE_MS = parseInt(root.getAttribute('data-auto-advance-ms'), 10) || 520;
    var ROTATE_MS = parseInt(root.getAttribute('data-rotate-ms'), 10) || 3200;
    var LOAD_STEP_MS = parseInt(root.getAttribute('data-load-step-ms'), 10) || 820;
    var LOAD_HOLD_MS = parseInt(root.getAttribute('data-load-hold-ms'), 10) || 950;
    var MICRO_FADE_MS = 300;
    var QUESTION_OUT_MS = 270;

    var backBtn = root.querySelector('[data-quiz-back]');
    var stepLabel = root.querySelector('[data-quiz-step]');
    var microEl = root.querySelector('[data-quiz-micro]');
    var progressFills = Array.prototype.slice.call(root.querySelectorAll('[data-progress-fill]'));
    var categoryEls = Array.prototype.slice.call(root.querySelectorAll('[data-category]'));
    var questionEl = root.querySelector('[data-quiz-question]');
    var eyebrowEl = root.querySelector('[data-question-eyebrow]');
    var titleEl = root.querySelector('[data-question-title]');
    var helperEl = root.querySelector('[data-question-helper]');
    var optionsEl = root.querySelector('[data-question-options]');
    var stickyCount = root.querySelector('[data-sticky-count]');
    var stickyBack = root.querySelector('[data-sticky-back]');
    var stickyContinue = root.querySelector('[data-sticky-continue]');
    var checklistItems = Array.prototype.slice.call(root.querySelectorAll('[data-checklist-item]'));
    var ringFill = root.querySelector('[data-ring-fill]');

    var state = { q: 0, picks: {} };
    var autoAdvanceTimer = null;
    var cappedTimer = null;

    window.__lpCoAonicQuizCleanup.push(function () {
      clearTimeout(autoAdvanceTimer);
      clearTimeout(cappedTimer);
    });

    function escapeHtml(s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    function isMulti(q) {
      return q.multi;
    }

    function sectionInfo(qIndex) {
      var q = QUESTIONS[qIndex];
      var pos = 1;
      var total = 0;
      for (var i = 0; i < QUESTIONS.length; i++) {
        if (QUESTIONS[i].sec === q.sec) {
          total++;
          if (i < qIndex) pos++;
        }
      }
      return { sec: q.sec, pos: pos, total: total };
    }

    function updateChrome() {
      var q = QUESTIONS[state.q];
      var info = sectionInfo(state.q);

      stepLabel.textContent = 'Step ' + info.pos + '/' + info.total;

      var showBack = state.q > 0 && !isMulti(q);
      backBtn.disabled = !showBack;
      backBtn.setAttribute('data-hidden', showBack ? 'false' : 'true');

      progressFills.forEach(function (fill, idx) {
        var scale = 0;
        if (idx < info.sec) scale = 1;
        else if (idx === info.sec) scale = info.pos / info.total;
        fill.style.transform = 'scaleX(' + scale + ')';
      });

      categoryEls.forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-category'), 10);
        var s = idx < info.sec ? 'complete' : (idx === info.sec ? 'active' : 'upcoming');
        el.setAttribute('data-state', s);
      });
    }

    function renderOptions() {
      var q = QUESTIONS[state.q];
      var picked = state.picks[state.q] || [];
      var multi = isMulti(q);
      var atCap = multi && picked.length >= q.max;

      optionsEl.setAttribute('role', multi ? 'group' : 'radiogroup');
      optionsEl.setAttribute('aria-label', q.title);
      optionsEl.innerHTML = '';

      q.options.forEach(function (opt, i) {
        var selected = picked.indexOf(i) !== -1;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'lp-co-aonic-complete-quiz__option';
        btn.setAttribute('data-selected', selected ? 'true' : 'false');
        btn.setAttribute('role', multi ? 'checkbox' : 'radio');
        btn.setAttribute('aria-checked', selected ? 'true' : 'false');
        if (multi && atCap && !selected) {
          btn.setAttribute('data-capped', 'true');
        }

        /* Mark FIRST (left), then the emoji+label body — per the design source. */
        var html = '';
        if (multi) {
          html += '<span class="lp-co-aonic-complete-quiz__option-mark lp-co-aonic-complete-quiz__option-mark--checkbox">' +
            '<svg class="lp-co-aonic-complete-quiz__option-check" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
            '<path d="M20 6 9 17l-5-5" stroke="#000000" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
        } else {
          html += '<span class="lp-co-aonic-complete-quiz__option-mark lp-co-aonic-complete-quiz__option-mark--radio">' +
            '<span class="lp-co-aonic-complete-quiz__option-mark-dot"></span></span>';
        }
        html += '<span class="lp-co-aonic-complete-quiz__option-body">';
        if (opt.emoji) {
          html += '<span class="lp-co-aonic-complete-quiz__option-emoji" aria-hidden="true">' + opt.emoji + '</span>';
        }
        html += '<span class="lp-co-aonic-complete-quiz__option-label">' + escapeHtml(opt.label) + '</span>';
        html += '</span>';
        btn.innerHTML = html;

        btn.addEventListener('click', function () {
          onOptionClick(i);
        });
        optionsEl.appendChild(btn);
      });
    }

    function updateStickyBar() {
      var q = QUESTIONS[state.q];
      var multi = isMulti(q);
      root.setAttribute('data-sticky-active', multi ? 'true' : 'false');
      if (!multi) return;

      var picked = state.picks[state.q] || [];
      var n = picked.length;
      if (n === 0) {
        stickyCount.textContent = '0/' + q.max + ' selected';
        stickyCount.setAttribute('data-state', 'empty');
      } else if (n >= q.max) {
        stickyCount.textContent = 'Maximum ' + q.max + ' — deselect one to change';
        stickyCount.setAttribute('data-state', 'capped');
      } else {
        stickyCount.textContent = n + '/' + q.max + ' selected';
        stickyCount.setAttribute('data-state', 'picked');
      }
      stickyContinue.disabled = n === 0;
    }

    function renderQuestion() {
      var q = QUESTIONS[state.q];
      eyebrowEl.textContent = q.eyebrow;
      titleEl.textContent = q.title;
      helperEl.textContent = q.helper;
      renderOptions();
      updateChrome();
      updateStickyBar();
    }

    function flashCapped() {
      var q = QUESTIONS[state.q];
      stickyCount.textContent = 'Maximum ' + q.max + ' — deselect one to change';
      stickyCount.setAttribute('data-state', 'capped');
      clearTimeout(cappedTimer);
      cappedTimer = setTimeout(updateStickyBar, 1400);
    }

    function onOptionClick(i) {
      var q = QUESTIONS[state.q];
      var picked = state.picks[state.q] || [];

      if (isMulti(q)) {
        var idx = picked.indexOf(i);
        if (idx !== -1) {
          picked.splice(idx, 1);
        } else if (picked.length >= q.max) {
          flashCapped();
          return;
        } else {
          picked.push(i);
        }
        state.picks[state.q] = picked;
        renderOptions();
        updateStickyBar();
      } else {
        state.picks[state.q] = [i];
        renderOptions();
        clearTimeout(autoAdvanceTimer);
        autoAdvanceTimer = setTimeout(goNext, AUTO_ADVANCE_MS);
      }
    }

    function goNext() {
      if (state.q < QUESTIONS.length - 1) {
        transitionTo(state.q + 1);
      } else {
        startLoading();
      }
    }

    function goBack() {
      if (state.q > 0) transitionTo(state.q - 1);
    }

    function transitionTo(newIndex) {
      clearTimeout(autoAdvanceTimer);
      questionEl.setAttribute('data-phase', 'out');
      setTimeout(function () {
        state.q = newIndex;
        renderQuestion();
        questionEl.setAttribute('data-phase', 'in');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            questionEl.removeAttribute('data-phase');
          });
        });
      }, QUESTION_OUT_MS);
    }

    backBtn.addEventListener('click', goBack);
    stickyBack.addEventListener('click', goBack);
    stickyContinue.addEventListener('click', goNext);

    var microIndex = 0;
    function rotateMicro() {
      microEl.setAttribute('data-fade', 'out');
      setTimeout(function () {
        microIndex = (microIndex + 1) % MICROCOPY.length;
        microEl.textContent = MICROCOPY[microIndex];
        microEl.removeAttribute('data-fade');
      }, MICRO_FADE_MS);
    }
    microEl.textContent = MICROCOPY[0];
    window.__lpCoAonicQuizTimer = setInterval(rotateMicro, ROTATE_MS);

    function startLoading() {
      root.classList.remove('lp-co-aonic-complete-quiz--view-quiz');
      root.classList.add('lp-co-aonic-complete-quiz--view-loading');

      checklistItems.forEach(function (item) {
        item.setAttribute('data-state', 'pending');
      });
      if (checklistItems.length) checklistItems[0].setAttribute('data-state', 'active');

      var totalMs = LOAD_STEP_MS * 3 + LOAD_HOLD_MS;
      if (ringFill) {
        ringFill.style.transitionDuration = totalMs + 'ms';
        requestAnimationFrame(function () {
          ringFill.style.strokeDashoffset = '0';
        });
      }

      for (var i = 1; i < checklistItems.length; i++) {
        (function (i) {
          setTimeout(function () {
            checklistItems[i - 1].setAttribute('data-state', 'done');
            checklistItems[i].setAttribute('data-state', 'active');
          }, LOAD_STEP_MS * i);
        })(i);
      }

      setTimeout(function () {
        if (checklistItems.length) {
          checklistItems[checklistItems.length - 1].setAttribute('data-state', 'done');
        }
        showResults();
      }, totalMs);
    }

    function showResults() {
      root.classList.remove('lp-co-aonic-complete-quiz--view-loading');
      root.classList.add('lp-co-aonic-complete-quiz--view-results');
    }

    var modalRoot = document.getElementById('lp-co-aonic-complete-quiz-modal');
    if (modalRoot) {
      var modalOverlay = modalRoot.querySelector('[data-modal-overlay]');
      var modalCard = modalRoot.querySelector('[data-modal-card]');
      var modalClose = modalRoot.querySelector('[data-modal-close]');
      var modalTabs = Array.prototype.slice.call(modalRoot.querySelectorAll('[data-modal-tab]'));
      var modalPanels = Array.prototype.slice.call(modalRoot.querySelectorAll('[data-modal-panel]'));
      var openModalBtn = root.querySelector('[data-open-facts]');
      var lastFocused = null;
      var lockedScrollY = 0;

      function setModalTab(name) {
        modalTabs.forEach(function (t) {
          var active = t.getAttribute('data-modal-tab') === name;
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        modalPanels.forEach(function (p) {
          p.hidden = p.getAttribute('data-modal-panel') !== name;
        });
      }

      function getFocusable() {
        return Array.prototype.slice.call(
          modalCard.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
        ).filter(function (el) {
          return !el.disabled && el.offsetParent !== null;
        });
      }

      function onModalKeydown(e) {
        if (e.key === 'Escape' || e.key === 'Esc') {
          closeModal();
          return;
        }
        if (e.key === 'Tab') {
          var focusable = getFocusable();
          if (!focusable.length) return;
          var first = focusable[0];
          var last = focusable[focusable.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }

      function clearBodyLock() {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
      }

      function lockScroll() {
        lockedScrollY = window.scrollY || window.pageYOffset || 0;
        document.body.style.position = 'fixed';
        document.body.style.top = (lockedScrollY * -1) + 'px';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
      }

      function unlockScroll() {
        clearBodyLock();
        window.scrollTo(0, lockedScrollY);
      }

      function openModal(trigger) {
        lastFocused = trigger || document.activeElement;
        setModalTab('hers');
        lockScroll();
        modalRoot.classList.add('is-open');
        modalRoot.setAttribute('aria-hidden', 'false');
        modalCard.focus({ preventScroll: true });
        document.addEventListener('keydown', onModalKeydown);
      }

      function closeModal() {
        modalRoot.classList.remove('is-open');
        modalRoot.setAttribute('aria-hidden', 'true');
        unlockScroll();
        document.removeEventListener('keydown', onModalKeydown);
        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus({ preventScroll: true });
        }
      }

      /* If the editor re-renders the section while the modal is open, drop the
         document-level key handler and release the body scroll lock. */
      window.__lpCoAonicQuizCleanup.push(function () {
        document.removeEventListener('keydown', onModalKeydown);
        if (modalRoot.classList.contains('is-open')) clearBodyLock();
      });

      if (openModalBtn) {
        openModalBtn.addEventListener('click', function (e) {
          e.preventDefault();
          openModal(openModalBtn);
        });
      }
      modalClose.addEventListener('click', closeModal);
      modalOverlay.addEventListener('click', closeModal);
      modalTabs.forEach(function (t) {
        t.addEventListener('click', function () {
          setModalTab(t.getAttribute('data-modal-tab'));
        });
      });
    }

    renderQuestion();
  }

  /* Only react to load/unload events for THIS section. */
  function isOurSection(e) {
    if (!e || !e.target) return true;
    if (e.target.id === ROOT_ID) return true;
    return !!(e.target.querySelector && e.target.querySelector('#' + ROOT_ID));
  }

  /* Bind the document-level listeners once per page. Inline section scripts are
     not guaranteed to re-execute on an editor re-render, so these persistent
     listeners — not this script re-running — are what drive re-initialization. */
  if (!window.__lpCoAonicQuizBound) {
    window.__lpCoAonicQuizBound = true;
    document.addEventListener('shopify:section:load', function (e) {
      if (isOurSection(e)) init();
    });
    document.addEventListener('shopify:section:unload', function (e) {
      if (isOurSection(e)) teardown();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
